import { IsBoolean, IsNumber, IsOptional, IsString } from "class-validator";
import { Expose } from "class-transformer";

export class CostDocumentDataAfterPair {
  @Expose()
  @IsBoolean()
  differentCurrencies!: boolean;
  @Expose()
  @IsNumber()
  costDocumentItemId!: number;
  @Expose()
  @IsString()
  documentItemId!: string;
  @Expose()
  @IsBoolean()
  costDocumentItemCanSettled!: boolean;
  @Expose()
  @IsBoolean()
  documentItemCanSettled!: boolean;
  @Expose()
  @IsBoolean()
  documentItemCanWriteOff!: boolean;
  @Expose()
  @IsNumber()
  pairedAmount!: number;
  @Expose()
  @IsOptional()
  @IsString()
  automaticSettledMessage!: string;
}

export class UpdatePairCostDocumentItem {
  @Expose()
  @IsString()
  documentItemId!: string;
  @Expose()
  @IsNumber()
  pairAmount!: number;
}
